/**
 * The Get Started checklist outside `/onboarding`: it follows the member
 * around the app while their onboarding is open. A step or firm item takes
 * them back to the conversation; dismissing hides it for good (the account
 * menu's Get Started brings it back).
 */
import type { FC } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { lawyerSelectors } from "../../../redux/lawyer/selectors";
import { dismissOnboarding, useOnboarding } from "../hooks/useOnboarding";
import { isOnboardingPath, ONBOARDING_PATH, showsChecklist } from "../routes";
import { GetStartedChecklist } from "./GetStartedChecklist";

export const AppChecklist: FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const status = useSelector(lawyerSelectors.selectOnboardingStatus);
  const visible = showsChecklist(status) && !isOnboardingPath(pathname);
  const { progress } = useOnboarding(visible);
  if (!visible || !progress || !showsChecklist(progress.status)) return null;
  const open = () => navigate(ONBOARDING_PATH);
  return (
    <GetStartedChecklist
      progress={progress}
      defaultCollapsed
      className="fixed right-4 bottom-4 z-40"
      onStep={open}
      onFirmItem={open}
      onDismiss={() => {
        dismissOnboarding().catch(() =>
          toast.error("Could not hide the checklist. Try again.")
        );
      }}
    />
  );
};
